import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeatureGrid from './components/FeatureGrid';
import AboutSection from './components/AboutSection';
import TestimonialSection from './components/TestimonialSection';
import CaseStudiesSection from './components/CaseStudiesSection';
import TrustSignalsSection from './components/TrustSignalsSection';
import ArticlesSection from './components/ArticlesSection';
import CTASection from './components/CTASection';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Mulebuy Spreadsheet',
  url: import.meta.env.VITE_SITE_URL || 'https://mulebuyspreadsheets.boats',
  description: 'Discover the Mulebuy Spreadsheet system for efficient product sourcing, category organization, and workflow optimization.',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${import.meta.env.VITE_SITE_URL || 'https://mulebuyspreadsheets.boats'}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeatureGrid />
        <AboutSection />
        <CaseStudiesSection />
        <TestimonialSection />
        <TrustSignalsSection />
        <ArticlesSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}